import { Link } from '@reach/router';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';

import opswatLogo from 'assets/images/v2/opswat-logo.svg';
import LoadingLayout from 'components/layout/loadingLayout';
import { OPSWAT_PRIVACY_POLICY_URL, OPSWAT_TERMS_OF_SERVICE_URL } from 'services/Constant';

import CommonContextV2 from '../common-context/context';

import './common-layout.scss';

const footerLinks = [
    {
        label: 'Privacy Policy',
        url: OPSWAT_PRIVACY_POLICY_URL
    },
    {
        label: 'Terms of Service',
        url: OPSWAT_TERMS_OF_SERVICE_URL
    }
];

const CommonLayoutV2 = ({ pageTitle, pageDescription, isLoading, children, contentStyles }) => {
    const { productInfo } = useContext(CommonContextV2);

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name='description' content={pageDescription} />
            </Helmet>
            {isLoading ? (
                <LoadingLayout title={pageTitle} />
            ) : (
                <div className='common-layout__container'>
                    <div className='common-layout__content'>
                        <div className='common-layout__card-container'>
                            <div className='common-layout__card-content' style={contentStyles}>
                                <div className='common-layout__card-title'>
                                    <span className='product-prefix'>{productInfo.productPrefix}</span>
                                    <span className='product-name'>{productInfo.productName}</span>
                                </div>
                                {children}
                            </div>
                            <div className='common-layout__card-footer' />
                        </div>
                        <div className='common-layout__footer-container'>
                            <Link to={'/' + (window?.location?.search || '')}>
                                <img src={opswatLogo} alt='OPSWAT Logo' />
                            </Link>
                            <div className='common-layout__footer-links'>
                                {footerLinks.map((link, index) => (
                                    <a key={index} href={link.url} target='_blank' rel='noopener noreferrer'>
                                        {link.label}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CommonLayoutV2;

CommonLayoutV2.propTypes = {
    pageTitle: PropTypes.string,
    pageDescription: PropTypes.string,
    isLoading: PropTypes.bool,
    children: PropTypes.node,
    contentStyles: PropTypes.object
};
